export default __webpack_public_path__ + "static/media/icon-metamask.44edc8ee.svg";